import { withPrefix } from 'gatsby';
import createRedirect from './create-redirect';

export default createRedirect(withPrefix('/'));
